<template>
  <div class="dplayerEle" @click="dplayerClick">
    <div v-if="config.isForbidden" class="Markups" :class="{'active': show}"></div>
    <div ref="dplayer" class="dplayer"></div>
  </div>
</template>

<script>
import DPlayer from "dplayer";
export default {
  name: "DPlayer",
  props: {
    config: {
      type: Object,
      default: function () {
        return {
          flvUrl: "",
          m3u8Url: "",
          isForbidden: true,
          index: 0,
          refreshTime: 60
        };
      },
    },
  },
  data() {
    return {
      show: false,
      errors: false,
      times: null, // 定时器
      errorTime: null,
      n: 0,
      dp: {},
      interval: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var self = this;
      const options = {
        container: this.$refs.dplayer,
        autoplay: true,
        theme: "#1e62fc",
        hotkey: false,
        playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2],
        preload: "metadata",
        mutex: false,
        video: {
          url: "",
        },
      };
      if (this.$tu.judgeEnviroment() === "ios") {
        options.video.url = this.config.m3u8Url;
      } else if (this.$tu.judgeEnviroment() === "android") {
        options.video.url = this.config.flvUrl;
      } else if (this.$tu.judgeEnviroment() === "weixin") {
        options.video.url = this.config.flvUrl;
      } else {
        options.video.url = this.config.flvUrl;
      }
      if (!this.config.flvUrl && !this.config.m3u8Url) {
        console.error("请传入url视频地址");
        return;
      }
      this.dp = new DPlayer(options);

      this.show = true;
      this.dp.on("loadeddata", function (data) {
        if (self.config.isForbidden) {
          document.getElementsByClassName("dplayer-controller")[
            self.config.index
          ].style.display = "none";
        } else {
          this.show = false;
        }
      });
      this.dp.on("error", function (data) {
        console.log("error");
        self.errors = true;
      });
      this.dp.on("abort", function (data) {
        console.log("abort");
      });
      this.dp.on("canplay", function (data) {
        self.n = 0;
        clearInterval(self.interval);
        console.log("canplay");
      });
      this.dp.on("canplaythrough", function (data) {
        self.n = 0;
        clearInterval(self.interval);
        console.log("canplaythrough");
      });
      this.dp.on("durationchange", function (data) {
        console.log("durationchange");
      });
      this.dp.on("emptied", function (data) {
        console.log("emptied");
      });
      this.dp.on("ended", function (data) {
        console.log("ended");
      });
      this.dp.on("loadedmetadata", function (data) {
        console.log("loadedmetadata");
      });
      this.dp.on("loadstart", function (data) {
        console.log("loadstart");
      });
      this.dp.on("mozaudioavailable", function (data) {
        console.log("mozaudioavailable");
      });
      this.dp.on("pause", function (data) {
        console.log("pause");
      });
      this.dp.on("ratechange", function (data) {
        console.log("ratechange");
      });
      this.dp.on("progress", function (data) {
        console.log("progress");
      });
      this.dp.on("seeked", function (data) {
        console.log("seeked");
      });
      this.dp.on("seeking", function (data) {
        console.log("seeking");
      });
      this.dp.on("suspend", function (data) {
        console.log("suspend");
      });
      this.dp.on("timeupdate", function (data) {
        console.log("timeupdate");
      });
      this.dp.on("waiting", function (data) {
        clearInterval(self.interval);
        self.interval = setInterval(() => {
          self.n++;
          console.log(self.n);
          if (self.n >= (self.config.refreshTime?self.config.refreshTime:60)) {
            clearInterval(self.interval);
            self.n = 0;
            self.dp.destroy();
            self.init();
          }
        }, 1000);
        console.log("waiting");
      });
// this.dp.play();
      // this.dp.on("stalled", function (data) {
      //   clearTimeout(self.errorTime);
      //   self.errorTime = setTimeout(() => {
      //     self.dp.destroy();
      //     self.init();
      //   }, 10000);
      //   console.log("stalled");
      // });
    },
    /*
     * 由于移动端没有鼠标离开进入事件 所以 进度条一旦显示就不会隐藏 这里需要做处理
     */
    dplayerClick() {
      clearTimeout(this.times);
      if (this.jquery(".dplayer-hide-controller").length === 0) {
        this.times = setTimeout(() => {
          this.jquery(".dplayer").addClass("dplayer-hide-controller");
        }, 4000);
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.times);
    clearTimeout(this.errorTime);
    clearInterval(this.interval);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dplayer,
.dplayerEle {
  position: relative;
  width: 100%;
  height: 100%;
}
.Markups {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: black;
  z-index: 1000000000000;
}
.active {
  background-color: transparent !important;
}
.dplayer >>> .dplayer-bar {
  height: 12px !important;
}
.dplayer >>> .dplayer-thumb {
  height: 0.22rem !important;
  width: 0.22rem !important;
}
.dplayer >>> .dplayer-played {
  background: #1e62fc !important;
}
.dplayer >>> .dplayer-bar-wrap:hover .dplayer-highlight {
  height: 100% !important;
}
.dplayer >>> .dplayer-bar-wrap .dplayer-highlight {
  height: 100% !important;
}
.dplayer >>> .dplayer-bar-wrap .dplayer-bar .dplayer-played .dplayer-thumb {
  transform: scale(1) !important;
}
.dplayer >>> .dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-loaded,
.dplayer
  >>> .dplayer-controller
  .dplayer-bar-wrap
  .dplayer-bar
  .dplayer-played {
  height: 0.15rem !important;
}
.dplayer
  >>> .dplayer-controller
  .dplayer-bar-wrap
  .dplayer-bar
  .dplayer-played
  .dplayer-thumb {
  margin-top: -0.06rem !important;
}
.dplayerEle >>> .dplayer-hide-controller .dplayer-thumb {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dplayer/dplayer.vue